<script setup>
  import ComponentBreadcrumb from "@components/Breadcrumb/Breadcrumb.vue";
  import ContactsContactForm from "@pages/Contact/Components/ContactForm.vue";

  defineOptions({
    name: "PagesContactCreate",
  });

  defineProps({
    contact: {
      type: Object,
      default: null,
    },
  });
</script>

<template>
  <ComponentBreadcrumb
    class="mt-2"
    :links="[
      {
        label: 'Kontakte',
        url: $route('contacts.index'),
      },
      {
        label: contact !== null ? 'Kontakt bearbeiten' : 'Neuer Kontakt',
      },
    ]"
  />

  <section>
    <div class="px-4 pt-4">
      <h2 class="text-2xl font-semibold" v-text="contact !== null ? 'Kontakt bearbeiten' : 'Neuer Kontakt'" />
    </div>

    <article class="flex flex-col items-start space-y-6 p-4 lg:flex-row lg:space-y-0 lg:space-x-6">
      <div class="w-full space-y-6 lg:max-w-4xl">
        <ContactsContactForm :contact="contact" />
      </div>
    </article>
  </section>
</template>
